"use strict";

exports.__esModule = true;
var _ReportListAccordianView = require("./ReportListAccordianView");
Object.keys(_ReportListAccordianView).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportListAccordianView[key]) return;
  exports[key] = _ReportListAccordianView[key];
});
var _ReportListAccordianView2 = require("./ReportListAccordianView.qa");
Object.keys(_ReportListAccordianView2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportListAccordianView2[key]) return;
  exports[key] = _ReportListAccordianView2[key];
});